import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';

export type DisplayType = 'total' | 'network' | 'encode';

export type LatencyDisplayTypeProps = {
    displayType: DisplayType;
    onChange: (displayType: DisplayType) => void;
}

export function LatencyDisplayType(props: LatencyDisplayTypeProps) {
    const { displayType, onChange } = props;

    const onChangeRadioItem = (event: { target: { value: React.SetStateAction<string>; }; }) => {
        onChange(event.target.value as DisplayType);
    };

    return (
        <div>
            <FormControl component='fieldset'>
                <FormLabel component='legend'></FormLabel>
                <RadioGroup aria-label='latency' name='latency1' value={displayType} onChange={onChangeRadioItem} row>
                    <FormControlLabel value='total' control={<Radio />} label='Total Latency' />
                    <FormControlLabel value='network' control={<Radio />} label='Network Latency' />
                    <FormControlLabel value='encode' control={<Radio />} label='Encode Time' />
                </RadioGroup>
            </FormControl>
        </div>
    );
}
